import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { ModalHeader } from "../../common/modalHeader";

const HelpModal = ({ open, handleClose }) => {
    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="help-modal-title"
        aria-describedby="help-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            borderRadius: "10px",
            transform: "translate(-50%, -50%)",
            width: { lg: "35%", xs: "96%", sm:"45%" },
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <ModalHeader title={"Help And Support"} onClose={handleClose} />
          <Box sx={{ padding: "20px", paddingRight: "70px" }}>
            <Typography
              sx={{
                color: "#000",
                fontWeight: "500",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              For any information, query, question, doubt, help or support
            </Typography>
            <Typography
              sx={{
                color: "#000",
                fontWeight: "600",
                mt: "20px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Please call us on +91-9209054709 or send mail to
              support@elegantprime.in
            </Typography>
          </Box>
        </Box>
      </Modal>
    );
}
export default HelpModal;